import { useMemo } from 'react'
import type { OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'
import useFixedFlashLengthOfStayExperiment from './useFixedFlashLengthOfStayExperiment'
import useFlashOfferLosCalendarExperiment from './useFlashOfferLosCalendarExperiment'

interface FlashOfferCalendarExperimentModeInput {
  isFlashOffer: boolean
  isLosEligible: boolean
  isLosVariant: boolean
  isFixedFlashVariant: boolean
  subFilters: Array<OfferPageFilterType>
}

interface FlashOfferCalendarExperimentMode {
  isFixedFlashLengthOfStayEnabled: boolean
  showLosCarousel: boolean
  calendarSubFilters: Array<OfferPageFilterType>
}

export function resolveFlashOfferCalendarExperimentMode(
  input: FlashOfferCalendarExperimentModeInput,
): FlashOfferCalendarExperimentMode {
  const losEnabled = input.isLosEligible && input.isLosVariant
  const isFixedFlashLengthOfStayEnabled = input.isFlashOffer && input.isFixedFlashVariant && !losEnabled
  const showLosCarousel = losEnabled
  const calendarSubFilters = (isFixedFlashLengthOfStayEnabled || showLosCarousel)
    ? input.subFilters.filter(filter => filter !== 'duration')
    : input.subFilters

  return {
    isFixedFlashLengthOfStayEnabled,
    showLosCarousel,
    calendarSubFilters,
  }
}

function useFlashOfferCalendarExperimentMode(
  isFlashOffer: boolean,
  canActivate: boolean,
  isLosEligible: boolean,
  subFilters: Array<OfferPageFilterType>,
): FlashOfferCalendarExperimentMode {
  const isLosVariant = useFlashOfferLosCalendarExperiment(canActivate && isLosEligible)
  const losEnabled = isLosEligible && isLosVariant
  const isFixedFlashVariant = useFixedFlashLengthOfStayExperiment(canActivate && !losEnabled)

  return useMemo(() => resolveFlashOfferCalendarExperimentMode({
    isFlashOffer,
    isLosEligible,
    isLosVariant,
    isFixedFlashVariant,
    subFilters,
  }), [isFixedFlashVariant, isFlashOffer, isLosEligible, isLosVariant, subFilters])
}

export default useFlashOfferCalendarExperimentMode
